import React, { useContext, useEffect, useState } from "react";
import { STEP_GROUP_IDS } from "../../../../shared/config";
import { useStepHandler } from "../../../../../utils/hooks/useStepHandler";
import { fakeFormsDataKYCManual } from "../../../../../utils/fakeFormsData";
import { ProcessContext } from "../../../../../contexts/ProcessContext";
import { devConsoleLog } from "../../../../../utils/devConsoleLog";
import { docIdSide, maritalRegimeTypesConfig } from "../../shared/config";
import { UserDetailsWithDeclaredDataMapper } from "../../../../../utils/mappers/MainUserDetails/MainUserDetailsMapper";
import { KYC_MANUAL_NAMES } from "../config";
import { FLOW_MESSAGES } from "../../../../shared/components/flowMessages/components";
import Text from "../../../../shared/components/Text";

export const useKycManual = ({
  disableMaritalRegime,
  STEP_GROUP_STEPS_ARRAY,
}) => {
  const CURRENT_STEP_GROUP = STEP_GROUP_IDS.KycManual;
  const {
    state: {
      loan,
      lastActionsReferenceLastChange,
      lastActionsReference,
      participant,
    },
    dispatch,
  } = useContext(ProcessContext);

  const [state, setState] = useState({
    formSubmitSuccess: false,
  });

  const { formSubmitSuccess } = state;

  const onSubmitIdPictures = (values) => {
    const documentType = getStepData(KYC_MANUAL_NAMES.DOC_ID_FORM).documentType;
    const imagesData = {
      loan_id: loan.id,
      borrower_id: participant.participantId,
      image_front: values[docIdSide[`${documentType}_FRONT`]].result,
      image_back: values[docIdSide[`${documentType}_BACK`]].result,
    };
    dispatch({
      type: "SET_FLOW_MESSAGE",
      payload: { id: FLOW_MESSAGES.SEND_OK.id, fadeIn: false },
    });
    dispatch({
      type: "REQUEST_POST_DOCUMENT_ID_IMAGES_ACTION",
      payload: {
        op: "postDocumentIdImagesAction",
        ...imagesData,
      },
    });
    submitStep(values);
  };

  const onSubmitModule = (values) => {
    devConsoleLog(stepGroupStepToShow);
    const newValues = {
      ...{
        ...values,
        address: { ...values.address, ...values.complementAddress },
      },
      ...(disableMaritalRegime && {
        maritalRegime: maritalRegimeTypesConfig.SEPARATE_PROPERTY.value,
      }),
    };

    const dehydratedData = UserDetailsWithDeclaredDataMapper.reverseMap(
      {
        ...newValues,
        loan,
      },
      participant
    );
    dispatch({
      type: "SET_FLOW_LOADING",
      payload: {
        show: true,
        loadingMessage: <Text tId="PLEASE_WAIT" />,
      },
    });
    dispatch({
      type: "REQUEST_PATCH_SET_USER_DETAILS_WITH_DECLARED_DATA",
      payload: dehydratedData,
    });
  };

  const currentModuleStepHandler = useStepHandler(
    onSubmitModule,
    fakeFormsDataKYCManual
  );

  const { manageGroup, submitStep, onBack, backButtonVisible, getStepData } =
    currentModuleStepHandler;
  const stepGroupStepToShow = manageGroup(
    CURRENT_STEP_GROUP,
    STEP_GROUP_STEPS_ARRAY
  );

  useEffect(() => {
    const isActionTypeInLastActionsReference = (actionType) =>
      lastActionsReference?.some((element) => element.type === actionType);

    if (formSubmitSuccess) {
      if (isActionTypeInLastActionsReference("REQUEST_GET_LOAN_FULFILLED")) {
        dispatch({
          type: "SET_FLOW_ITEM_OK",
        });
      }
    }
    if (
      isActionTypeInLastActionsReference(
        "REQUEST_PATCH_SET_USER_DETAILS_WITH_DECLARED_DATA_FULFILLED"
      )
    ) {
      setFormSubmitSuccess();
    }
  }, [formSubmitSuccess, lastActionsReferenceLastChange]);

  const setFormSubmitSuccess = () => {
    setState((s) => ({
      ...s,
      formSubmitSuccess: true,
    }));
  };

  return {
    currentModuleStepHandler,
    stepGroupStepToShow,
    CURRENT_STEP_GROUP,
    submitStep,
    onSubmitIdPictures,
    onBack,
    backButtonVisible,
    getStepData,
  };
};
